import cx from 'classnames';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';
import CommonImage from '@/components/CommonImage';
import CommonEquipment from '../CommonEquipment';
import { IAuhtor, IArticalAuther } from '@/api/detail';
import { getUserHomeUrl } from '@/constants/url';
import { isMobile } from '@/utils';
import { isStoreAppBannerEntry } from '@/utils/url';
import { getOptimizedImageUrl } from '@/utils/image';
import Styles from './mIndex.module.scss';

const noavatarImageUrl = `${process.env.RESOURCE_URL}uc_server/images/noavatar_middle.gif`

export interface IUserInfo {
  className?: string;
  author?: IAuhtor;
  avatar?: string;
  devices?: Array<NonNullable<IArticalAuther['device']>>;
  name: string;
  id: number;
  uuid: string;
  rank?: NonNullable<IArticalAuther['rank']>;
  total_distance: number;
  hide_distance?: boolean;
  handleClickAvatarCbk?: () => void
  /** 禁用用户信息点击 */
  disableClick?: boolean;
}

const UserInfo = ({
  className = '',
  avatar = '',
  devices = [],
  name,
  id,
  uuid,
  rank,
  total_distance,
  hide_distance,
  handleClickAvatarCbk,
  disableClick,
}: IUserInfo) => {
  const router = useRouter();
  const t = useTranslations();

  const handleClickAvatar = () => {
    if(disableClick) return;
     // 对外暴露埋点钩子
    handleClickAvatarCbk && handleClickAvatarCbk();
    if(typeof id === 'number' && !isStoreAppBannerEntry(router.query.entry)) {
      isMobile ? router.push(getUserHomeUrl(id, uuid)) : window.open(getUserHomeUrl(id, uuid));
    }
  };

  return (
    <div className={cx(Styles.root, className)}>
      <div
        className={cx(Styles.avatar, {[Styles.hasAuthor]: typeof id === 'number' && uuid})}
        onClick={handleClickAvatar}
        style={{ backgroundImage: `url(${getOptimizedImageUrl(avatar, 'webp', '550') || noavatarImageUrl})`}}
      />
      <div className={Styles.right}>
        <div className={Styles.usernameAndDevices}>
          <div className={Styles.username}>
            {name ? name : t('logout_user_info_nickname')}
          </div>
          {
            rank?.vpic && (
              <CommonImage
                alt={rank?.vname}
                src={require('@/assets/icon/V.png')}
                layout="fill"
                cutMode='cover'
                className={Styles.rankIcon}
              />
            )
          }
          {
            devices.length > 0 && (
              <div className={Styles.devices}>
                {
                  devices.slice(0, 1).map(({ name, key, icon, home_page }: NonNullable<IArticalAuther['device']>) => (
                    <div key={key}>
                      <CommonEquipment
                        disableClick={disableClick}
                        home_page={home_page}
                        name={name}
                        icon={icon}
                        className={Styles.device}
                      />
                    </div>
                  ))
                }
              </div>
            )
          }
        </div>
        {
          !hide_distance && typeof total_distance === 'number' && total_distance > 0 && <div className={Styles.distance}>{t('thread_total_distance', { distance: total_distance })}</div>
        }
      </div>
    </div>
  );
};

export default UserInfo;
